document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.hdt-product-variant-buttons-wrapper').forEach(function(wrapper) {
    const variants = JSON.parse(wrapper.dataset.variantsJson || '[]');
    const firstVariantId = wrapper.dataset.firstVariantId;

    const btnAdd = wrapper.querySelector('.btn-add-to-cart');
    const btnBuy = wrapper.querySelector('.btn-buy-now');
    const selectorColor = wrapper.querySelector('.variant-option-1');
    const selectorSize = wrapper.querySelector('.variant-option-2');

    // Debug logs
    console.log('Wrapper found', wrapper);
    console.log('Variants data:', variants);

    function updateButtons() {
      let selectedColor = selectorColor ? selectorColor.value : null;
      let selectedSize = selectorSize ? selectorSize.value : null;

      console.log('Selected Color:', selectedColor);
      console.log('Selected Size:', selectedSize);

      // Find matching variant
      let matched = variants.find(v => {
        let ok = true;
        if (selectedColor !== null) {
          ok = ok && (v.option1 == selectedColor);
        }
        if (selectedSize !== null) {
          ok = ok && (v.option2 == selectedSize);
        }
        return ok;
      });

      console.log('Matched variant:', matched);

      if (!matched) {
        btnAdd.disabled = true;
        btnBuy.disabled = true;
        btnAdd.dataset.variantId = "";
        btnBuy.dataset.variantId = "";
      } else {
        if (matched.available) {
          btnAdd.disabled = false;
          btnBuy.disabled = false;
          btnAdd.dataset.variantId = matched.id;
          btnBuy.dataset.variantId = matched.id;
        } else {
          btnAdd.disabled = true;
          btnBuy.disabled = true;
          btnAdd.dataset.variantId = "";
          btnBuy.dataset.variantId = "";
        }
      }
    }

    if (selectorColor) selectorColor.addEventListener('change', updateButtons);
    if (selectorSize) selectorSize.addEventListener('change', updateButtons);

    // Initialize buttons on page load
    updateButtons();

    btnAdd.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = btnAdd.dataset.variantId;
      if (!variantId) {
        console.log('Add to Cart clicked but variantId missing');
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [ { id: variantId, quantity: 1 } ] })
      })
      .then(r => r.json())
      .then(data => {
        console.log('Added to cart', data);
        // Optionally show success message or update cart icon
      })
      .catch(error => {
        console.error('Error adding to cart', error);
      });
    });

    btnBuy.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = btnBuy.dataset.variantId;
      if (!variantId) {
        console.log('Buy Now clicked but variantId missing');
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [ { id: variantId, quantity: 1 } ] })
      })
      .then(r => r.json())
      .then(data => {
        console.log('Buy Now — added to cart then redirect to checkout');
        window.location.href = '/checkout';
      })
      .catch(error => {
        console.error('Error buying now', error);
      });
    });
  });
});
